"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C64Layout_1 = require("./C64Layout");
class ArtStudioPicture {
    constructor() {
        this.formatName = 'artstudio';
        this.defaultExtension = 'art';
    }
    fromPixelImage(pixelImage) {
        this.loadAddress = new Uint8Array(2);
        this.loadAddress[0] = 0;
        this.loadAddress[1] = 0x20;
        this.bitmap = C64Layout_1.default.convertBitmap(pixelImage);
        this.screenRam = C64Layout_1.default.convertScreenram(pixelImage, 0, 1);
        this.magic = new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00]);
    }
    toMemoryMap() {
        return [this.loadAddress, this.bitmap, this.screenRam, this.magic];
    }
}
exports.default = ArtStudioPicture;
//# sourceMappingURL=ArtStudioPicture.js.map